import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import axios from "../../axios";
import { NotificationManager } from "react-notifications";
const UploadDialog = (props) => {
  const [file, setFile] = useState();
  const [accept,setAccept] = useState(false)
  const [errors,setErrors] = useState([])
  const [errorHeading,setErrorHeading] = useState("")
  const [disabled,setDisabled] = useState(false)

  const onFileChange = (event) => {

    setFile(event.target.files[0]);

  };
  const handleCheckBoxClicked = (e) => {
    setAccept(e.target.checked);
  };
  const handleClose = () => {
    setErrors([])
    setErrorHeading("")
    setFile()
    props.handleClose();
  }
  const onSubmit = () => {
    setDisabled(true)
    console.log(file);
    var formData = new FormData();
    formData.append("SMS",accept)
    formData.append("file", file);

    axios
      .post("/send_bulk_assessment_link", formData, {
        headers: {
          accessToken: localStorage.accessToken,
        },
      })
      .then((response) => {
        setErrors(response.data["error_list"])
        if(response.data["error_list"].length)
          setErrorHeading("Upload Errors")
        NotificationManager.success(response.data.message, "Success", 3000);
        setDisabled(false)
      })
      .catch((error) => {
        console.log(error);
        NotificationManager.error("Couldn't Upload File", "", 3000);
        setDisabled(false)
      });
  };

  return (
    <Dialog open={props.open}>
      <div className="dialog">
        <div className="dialog__header">Upload Excel File</div>

        <input
          type="file"
          className="fileBox"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          onChange={onFileChange}
        />
        <div className="container-flex">
        <input
                    className="checkboxAgreed"
                    type="checkbox"
                    value="accept"

                    onChange={handleCheckBoxClicked}
                  />
                  <label className="checkboxText">
                   Send SMS
                  </label>
        </div>
       <div className="errorsContent">
        <p className="errorsHeading">
{errorHeading}
        </p>
    
      {errors.map(e => (
        <li className="errors">{e}</li>
      ))}
    
       </div>
        <div className="d-grid buttons justify-content-around">
          <button
            className="btn secondary-button"
            onClick={handleClose}
          >
            Close
          </button>
          
          <button className="btn primary-button" onClick={onSubmit} disabled={disabled}>
            Submit
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default UploadDialog;
